import { Injectable } from '@angular/core';

// Mediates the shared OMP modals (image gallery, product selector, icon picker): the sidebar hosts them and
// registers open/close callbacks; consumers call pickImage()/pickProducts()/pickIcon() and await a Promise.
@Injectable()
export class OmpPickerService {
  // Registered by the host (sidebar) which owns the modal markup.
  public openImageModal: () => void = null;
  public closeImageModal: () => void = null;
  public openProductModal: () => void = null;
  public closeProductModal: () => void = null;
  public openIconModal: () => void = null;
  public closeIconModal: () => void = null;

  // Pre-selected product objects for the product modal's [selections] binding.
  public productSelections: any[] = [];

  public iconSelection = '';

  private imageResolver: (image: any) => void = null;
  private productResolver: (products: any[]) => void = null;
  private iconResolver: (icon: string) => void = null;

  // ---- Image gallery ----
  pickImage(): Promise<any> {
    return new Promise((resolve) => {
      if (this.openImageModal) {
        this.imageResolver = resolve;
        this.openImageModal();
      } else {
        resolve(null);
      }
    });
  }

  hasPendingImage(): boolean {
    return this.imageResolver !== null;
  }

  // Host calls this when an image is chosen (or null when the modal is dismissed).
  completeImage(image: any) {
    const resolver = this.imageResolver;
    this.imageResolver = null;
    if (this.closeImageModal) {
      this.closeImageModal();
    }
    if (resolver) {
      resolver(image);
    }
  }

  // ---- Product selector ----
  pickProducts(selections: any[]): Promise<any[]> {
    return new Promise((resolve) => {
      if (this.openProductModal) {
        this.productSelections = selections ? selections : [];
        this.productResolver = resolve;
        this.openProductModal();
      } else {
        resolve(null);
      }
    });
  }

  completeProducts(products: any[]) {
    const resolver = this.productResolver;
    this.productResolver = null;
    if (this.closeProductModal) {
      this.closeProductModal();
    }
    if (resolver) {
      resolver(products);
    }
  }

  pickIcon(current: string): Promise<string> {
    return new Promise((resolve) => {
      if (this.openIconModal) {
        this.iconSelection = current ? current : '';
        this.iconResolver = resolve;
        this.openIconModal();
      } else {
        resolve(null);
      }
    });
  }

  hasPendingIcon(): boolean {
    return this.iconResolver !== null;
  }

  completeIcon(icon: string) {
    const resolver = this.iconResolver;
    this.iconResolver = null;
    if (this.closeIconModal) {
      this.closeIconModal();
    }
    if (resolver) {
      resolver(icon);
    }
  }

  // Resolve a gallery image object to a usable URL string.
  fileUrl(image: any): string {
    let file = '';
    if (image) {
      file = image.file;
      if (file !== null && typeof file !== 'string') {
        file = file['original'] ? file['original'] : file['small'];
      }
    }
    return file ? file : '';
  }
}
